import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const BotService = {
    getBotsByFilter: async function (params, et) {
        try {
            // const response = await axiosApiInstance.get(BASE_URL + `/bot?environment_target=${et}${params ? `&filter=${JSON.stringify(params)}` : ''}`);
            const response = await axiosApiInstance.get(BASE_URL + `/bot`, { params: { environment_target: et, filter: params ? JSON.stringify(params) : '' } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBotDetails: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBotSecurityFilter: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/security-stage`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBotBusinessProcess: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/business-process`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getApplicationFilter: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/application`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCategoryFilter: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/category`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAutomationTypesFilter: async function (filter) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/automation-type${filter}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBotByUser: async function (target) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/user?environment_target=${target}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getApprovements: async function (status) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/approvements?status=${status}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    checkBotName: async function (name) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/check-name`, { params: { name, environment_target: 'global' } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    putApprovement: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + `/bot/publish-approve/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deletePublishRequest: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + `/bot/approvement/delete`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBotListByVendor: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/list`, { params: { environment_target: 'global' } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBotDetailForPublish: async function (id, latest_version) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/${id}/detail`, { params: { latest_version, environment_target: 'global' } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBotVersions: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/${id}/versions`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBotApplicationTypes: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/application-types`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getInitialFlow: async function (autom_version_id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/bot/initial/flow`, { params: { autom_version_id } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },

};

export default BotService;
